import React, { useEffect, useState } from "react";
import { InputProps, TextField } from "@mui/material";
import { Base } from "ui/Scripts/source/framework/base";

interface IFormIntegerProps {
    value: number;
    min?: number;
    max?: number;
    maxLength?: number;
    required?: boolean;
    InputProps?: Partial<InputProps>
    onChange: (value: number) => void;
}

export const FormInteger = (props: IFormIntegerProps) => {
    const [value, setValue] = useState("");
    const min = Base.isNullOrUndefined(props.min) ? 0 : props.min;
          
    useEffect(() => {
        if (!Base.isNullOrUndefined(props.value)) {
            let num = Math.max(props.value, min);
            if (!Base.isNullOrUndefined(props.max)) {
                num = Math.min(num, props.max);
            }
            setValue(num.toString(10));
        } else {
            setValue("");
        }
    }, [props.value]);

    const handleChange = (event) => {
        const value: string = event.target.value;
        if (!props.maxLength || !value || value.length <= props.maxLength) {
            setValue(event.target.value);
        }
        setValue(value.substring(0, props.maxLength));
    };

    const handleBlur = (event) => {
        const value: string = event.target.value;
        let newValue = value;
        let result: number = null;
        if (props.required || Base.hasNumber(value)) {
            result = Base.strToInteger(value, min, props.max);
            newValue = result.toString(10);
        } else {
            newValue = "";
        }
        setValue(newValue);
        props.onChange(result);
    };

    return (
        <TextField
            value={value}
            InputProps={{ ...props.InputProps, inputProps: { maxLength: props.maxLength } }}
            onChange={handleChange}
            onBlur={handleBlur}
        />
    );
};